export class ReportsResponse {
    Result: number;
    Reason: string;
    Response: any;
}